export const obj1 = {
  title: "1. What Are Cookies?",
  subTitle: "Cookies are small text files stored on your browser or device (computer, smartphone, tablet) when you visit a website. Cookies allow a site to recognize your device, remember preferences, secure user sessions, and gather usage analytics.",
}

export const obj2 = {
  title: "2. How We Use Cookies",
  subTitle: "InnerPal uses cookies and similar technologies for the following core purposes:",
  list: [
    {
      key: "Strictly Essential Cookies:",
      summary: "Required for the operation of InnerPal. They allow you to securely log in, navigate between pages, and access account dashboards."
    },
    {
      key: "Performance & Analytics Cookies:",
      summary: "Help us understand how users interact with our site, track page traffic, identify bottlenecks, and measure feature usage so we can continually enhance platform performance."
    },
    {
      key: "Functionality Cookies:",
      summary: "Remember your saved settings, selected preferences, time zone, and language choices to provide a smoother, more personalized experience."
    },
    {
      key: "Targeting & Marketing Cookies:",
      summary: "Used to deliver relevant advertisements and measure campaign effectiveness. These cookies track browsing habits across pages and may share data with authorized marketing networks."
    },
  ]
}

export const table1 = [
  { type: "Session Cookies", purpose: "Temporary cookies that maintain your active session and expire when you close your browser." },
  { type: "Persistent Cookies", purpose: "Cookies that remain stored on your device for a set period or until manually cleared." },
  { type: "First-Party Cookies", purpose: "Set directly by InnerPal.com for core site operations and preference saving." },
  { type: "Third-Party Cookies", purpose: "Set by external tools (e.g., Stripe, Google Analytics) integrated into InnerPal." },
]

export const obj4 = {
  title: "4. Third-Party Cookies & Integrations",
  subTitle: "We integrate trusted third-party services that may place cookies on your device:",
  otherTitle: "We do not directly control third-party cookie mechanisms and advise you to consult their respective privacy and cookie policies.",
  list: [
    { summary: "Stripe: Used for secure payment processing and fraud prevention during session and subscription checkout." },
    { summary: "Google Analytics: Used to analyze visitor traffic, session duration, and aggregate user interactions." },
    { summary: "Meta / Facebook Pixel: Used to measure advertising performance and deliver relevant social media ads." },
    { summary: "Mailchimp: Used for email newsletter analytics and tracking message engagement." },
  ]
}

export const obj5 = {
  title: "5. Managing & Opting Out of Cookies",
  subTitle: "You have full control over cookie settings on your device. You can configure your browser to block or delete cookies entirely.",
  subTitle1: "Please note: Disabling strictly essential cookies may prevent certain platform features (such as user login or session bookings) from working properly.",
  subTitle2: "Instructions for Managing Cookies in Major Browsers:",
  links: [
    { name: "Google Chrome", path: "https://support.google.com/chrome/answer/95647" },
    { name: "Mozilla Firefox", path: "https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" },
    { name: "Apple Safari", path: "https://support.apple.com/guide/safari/sfri11471/mac" },
    { name: "Microsoft Edge", path: "https://support.microsoft.com/en-us/windows/manage-cookies-in-microsoft-edge-view-allow-block-delete-and-use-168dab11-0753-043d-7c16-ede5947fc64d" },
  ]
}

export const obj6 = {
  title: "6. Updates to This Cookie Policy",
  subTitle: "We may update this Cookie Policy from time to time to reflect operational, technological, or regulatory changes. Updates will be published on this page with a revised effective date.",
}